import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "d-flex w-100 mb-2" }
const _hoisted_2 = { class: "table table-responsive-md border border-gray overflow-auto" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-table-header" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Description"),
    /*#__PURE__*/_createElementVNode("th", null, "Start Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Resolution Date"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-end" }, "Actions")
  ])
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableEmpty = _resolveComponent("TableEmpty")!
  const _component_ProblemsRow = _resolveComponent("ProblemsRow")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "btn btn-primary btn-xs ms-auto",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addProblem()))
      }, "Add Problem")
    ]),
    _createVNode(_component_Pagination, {
      ref: "paginationInstance",
      "page-changed": _ctx.pageChangedCallback,
      "is-loading": _ctx.isLoading,
      "page-size": _ctx.pageLimit,
      "show-page-size-options": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("table", _hoisted_2, [
          _hoisted_3,
          _createCommentVNode("Empty Table"),
          (_ctx.problems?.length === 0 && _ctx.newProblems?.length === 0)
            ? (_openBlock(), _createBlock(_component_TableEmpty, {
                key: 0,
                "col-span": _ctx.columns,
                component: "problem",
                "secondary-message": "No Problems to Display"
              }, null, 8 /* PROPS */, ["col-span"]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode("Existing Problems"),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.problems, (problem, index) => {
            return (_openBlock(), _createBlock(_component_ProblemsRow, {
              problem: problem,
              "move-problem-up": _ctx.moveProblem,
              "move-problem-down": _ctx.moveProblem,
              "delete-problem": _ctx.deleteProblem,
              onCancelEditProblem: _ctx.cancelEditProblemChanges,
              first: index === 0,
              last: index === _ctx.problems.length - 1,
              columns: _ctx.columns,
              "problems-length": _ctx.problems.length,
              index: index,
              "current-view": "edit"
            }, null, 8 /* PROPS */, ["problem", "move-problem-up", "move-problem-down", "delete-problem", "onCancelEditProblem", "first", "last", "columns", "problems-length", "index"]))
          }), 256 /* UNKEYED_FRAGMENT */)),
          _createCommentVNode("New Problems"),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newProblems, (problem, index) => {
            return _withDirectives((_openBlock(), _createBlock(_component_ProblemsRow, {
              problem: problem,
              "is-add-requested": _ctx.isAddRequested,
              "onUpdate:is-add-requested": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isAddRequested) = $event)),
              "save-new-problem": _ctx.saveNewProblem,
              "cancel-save-new-problem": _ctx.cancelSaveNewProblem,
              index: index,
              "current-view": "add"
            }, null, 8 /* PROPS */, ["problem", "is-add-requested", "save-new-problem", "cancel-save-new-problem", "index"])), [
              [_vShow, _ctx.newProblems.length > 0]
            ])
          }), 256 /* UNKEYED_FRAGMENT */))
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["page-changed", "is-loading", "page-size"])
  ], 64 /* STABLE_FRAGMENT */))
}